import axios, {AxiosInstance, isAxiosError} from "axios";
import {EnvService} from "../Env.service";
import {notification} from "antd";
import { AuthService } from "../Auth.service";
import {NavigateFunction} from "react-router-dom";
import {RoutingURL} from "../../model/models";

export class HttpService {
    private static axiosInstance: AxiosInstance;

    static init(navigate: NavigateFunction) {
        let customAxios = axios.create({
            baseURL: EnvService.getBackEndUrl(),
        });
        customAxios.interceptors.request.use(function (config){
            const token = AuthService.getToken();
            config.headers.Authorization =  token ? `Bearer ${token}` : '';
            return config;
        })
        customAxios.interceptors.response.use(function (response) {
                return response;
            },
            function (error) {
                if (isAxiosError(error)) {
                    if (error.response?.status === 401) {
                        notification.error({message: "Errore di autorizzazione."});
                        AuthService.clearSession();
                        navigate(RoutingURL.LOGIN);
                    }
                    if (error.response?.status === 404) {
                        notification.error({message: "Errore, risorsa non raggiungibile."});
                    }
                }

                return Promise.reject(error);
            })
        this.axiosInstance = customAxios;
    }

    static getInstanceAxios() {
        if (this.axiosInstance == null)
            throw new Error("Axios instance is null, call init() HttpService to create the instance");

        return this.axiosInstance;
    }
}